import { useState } from 'react';

import config from '../../config';

const useAppConfigState = () => {
	const [appConfig] = useState(config);
	return appConfig;
}

export default useAppConfigState;